<script setup lang="ts" generic="T">
import { useVModel } from '@vueuse/core';
import isEqual from 'lodash/isEqual';

import Radio from '@/components/base/form/Radio.vue';
import PillWrapper from '@/components/base/PillWrapper.vue';

const props = defineProps<{
  disabled?: boolean;
  modelValue?: T;
  value: T;
}>();

const emit = defineEmits(['update:modelValue']);

const selection = useVModel(props, 'modelValue', emit);
</script>

<template>
  <PillWrapper
    class="relative"
    :class="{ 'flex-col': $slots.below }"
    :disabled="disabled"
    :selected="isEqual(selection, value)"
    @click.self="selection = value"
  >
    <div v-if="disabled" class="absolute inset-0 w-full h-full bg-true-gray-100/80 rounded-4xl">
      <slot name="disabled" />
    </div>
    <Radio
      v-model="selection"
      :value="value"
      class="text-base"
      :class="{ grow: !$slots.right }"
      :disabled="disabled"
      :name="$attrs.name"
    >
      <slot />
    </Radio>
    <slot name="right" />
    <slot name="below" />
  </PillWrapper>
</template>
